import { DEFAULT_PAST_MONTHS_VISIBILITY_LIMIT } from "PFApp/constants/availability";
import { utc } from "PFCore/helpers/date";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useMemo } from "react";

const DEFAULT_PAST_MONTHS_COUNT = 3;

type UseMaxPastFetchesCountReturn = {
  maxPastFetchesCount: number;
  rangeMonthsDuration: number;
  pastMonthsVisibilityLimit: number;
  absoluteMin: string;
};

export const useMaxPastFetchesCount = (): UseMaxPastFetchesCountReturn => {
  const {
    data: { availability }
  } = useMyAccountInfo();
  const { formatDatabaseDateTime } = useDateFormatter();
  const rangeMonthsDuration = availability?.default_range_months_duration ?? DEFAULT_PAST_MONTHS_COUNT;
  const pastMonthsVisibilityLimit =
    availability?.past_months_visibility_limit ?? DEFAULT_PAST_MONTHS_VISIBILITY_LIMIT;

  const maxPastFetchesCount =
    pastMonthsVisibilityLimit > rangeMonthsDuration
      ? Math.ceil(pastMonthsVisibilityLimit / rangeMonthsDuration)
      : 0;

  const absoluteMin = useMemo(
    () =>
      formatDatabaseDateTime(
        utc()
          .startOf("day")
          .subtract(pastMonthsVisibilityLimit * rangeMonthsDuration, "months")
      ),
    [pastMonthsVisibilityLimit, rangeMonthsDuration]
  );

  return {
    maxPastFetchesCount,
    rangeMonthsDuration,
    pastMonthsVisibilityLimit,
    absoluteMin
  };
};
